export default __webpack_public_path__ + "static/clients-vrcity-logo-f0b81a1d003e9161bd0973a471982ad3.svg";